//生产地址
const configProduction = {
  backendBaseUrl: 'https://spreadapi.fujfu.com', //后台地址
  backendUrl: 'https://spread.fujfu.com', //前端域名
  wxSignUrl: 'https://wxSignature.fujfu.com/jsApiSign', //微信签名地址
  ipUrl: 'http://pv.sohu.com'
}

//uat环境地址
const configUat = {
  backendBaseUrl: 'https://spreadapi-uat.fujfu.com', //后台地址
  backendUrl: 'https://spread-uat.fujfu.com', //前端域名
  wxSignUrl: 'https://wxSignature.fujfu.com/jsApiSign', //微信签名地址
  ipUrl: 'http://pv.sohu.com'
}

//开发环境地址
const configDev = {
  backendBaseUrl: 'https://spreadapi-uat.fujfu.com', //后台地址
  // backendBaseUrl: 'http://192.168.93.13:8090', //后台地址
  backendUrl: 'http://localhost:3000', //前端域名
  wxSignUrl: 'https://wxSignature.fujfu.com/jsApiSign', //微信签名地址
  ipUrl: 'http://pv.sohu.com'
}

const config = () => {
  if (process.env.REACT_APP_SECRET_ENV === 'production') {
    return configProduction;
  } else if (process.env.REACT_APP_SECRET_ENV === 'uat') {
    return configUat;
  }
  return configDev;
}

export default config();
